<template>
  <router-view></router-view>
  <!-- The above router view is: To display the bottom sheet -->
  <div class="blackTransBg">
    <h2 class="mealHeading">Starters</h2>
  </div>
  <div class="card-container">
    <base-card v-for="type in mealType" :key="type.name" :cardContent="type" />
  </div>
</template>

<style scoped>
.transBg {
  border-radius: 20px;
  box-shadow: 0px 10px 100px 22px rgba(0, 0, 0, 0.1);

  display: grid;
  place-items: center;
  background-color: rgba(0, 0, 0, 0.731);
  backdrop-filter: blur(4px);
  margin-bottom: 2rem;
}
</style>

<script>
export default {
  data() {
    return {
      mealType: [
        { name: "Chicken", path: "chicken-starters" },
        { name: "Mutton", path: "mutton-starters" },
        { name: "Fish", path: "fish-starters" },
        { name: "Veg", path: "veg-starters" },
      ],
    };
  },
};
</script>
